import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getUrlParams, getGoqiiUserId } from "../apiService/timespam";
import { lifestyleApi } from "../apiService/api";
import "./Theme.css";
import "./ReportFlareUpStats.css";

const ReportFlareUpStats = () => {
  const { t } = useTranslation();
  const { theme, lang } = getUrlParams();
  const urlParams = new URLSearchParams(window.location.search);
  const uuid = urlParams.get("uuid") || "";
  const goqiiUserId = getGoqiiUserId();
  const nonce = urlParams.get("nonce") || "";
  const apiKey = urlParams.get("apiKey") || "";
  const signature = urlParams.get("signature") || "";
  const goqiiAccessToken = urlParams.get("goqiiAccessToken") || "";
  const authToken = urlParams.get("authToken") || "";
  const uid = urlParams.get("uid") || "";
  const action = urlParams.get("action") || "";

  const [stats, setStats] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    document.documentElement.className = theme === "dark" ? "dark" : "";
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
  }, [theme, lang]);

  useEffect(() => {
    lifestyleApi
      .fetchFlareUpStats()
      .then((res) => {
        if (res?.data?.scoreResponse) {
          setStats([...res.data.scoreResponse].reverse());
        }
      })
      .catch((err) => console.error("fetchFlareUpStats:", err))
      .finally(() => setLoading(false));
  }, []);

  const buildQs = () =>
    `uuid=${uuid}&uid=${uid}&goqiiuserid=${goqiiUserId}&nonce=${nonce}&apiKey=${apiKey}&signature=${signature}&goqiiAccessToken=${goqiiAccessToken}&authToken=${authToken}&theme=${theme}&lang=${lang}`;

  const formatDate = (dateStr) => {
    const months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
    const d = new Date(dateStr.replace(/-/g, "/"));
    return `${String(d.getDate()).padStart(2,"0")}-${months[d.getMonth()]}-${d.getFullYear()}`;
  };

  const grouped = stats.reduce((acc, item) => {
    const date = formatDate(item.createdTime);
    if (!acc[date]) acc[date] = [];
    acc[date].push(item);
    return acc;
  }, {});

  return (
    <>
      <section className="rfus-page">
        {loading ? (
          <div className="rfus-loading">{t("common.loading", "Loading...")}</div>
        ) : stats.length === 0 ? (
          <div className="rfus-empty">
            <p>{t("flareUpStats.noRecord", "No records found")}</p>
          </div>
        ) : (
          Object.entries(grouped).map(([date, items]) => (
            <React.Fragment key={date}>
              <div className="rfus-date-label">{date}</div>
              {items.map((item, idx) => (
                <div key={idx} className="rfus-card">
                  {item["1"] && (
                    <p className="rfus-rate">
                      <strong>{t("flareUpStats.rate", "Flare-up Rate")}:</strong> {item["1"][0]}
                    </p>
                  )}
                  {item["2"] && item["2"].length > 0 && (
                    <>
                      <p className="rfus-triggers-label">
                        <strong>{t("flareUpStats.triggers", "Triggers")}:</strong>
                      </p>
                      <ul className="rfus-triggers-list">
                        {item["2"].map((reason, i) => (
                          <li key={i}>{reason}</li>
                        ))}
                      </ul>
                    </>
                  )}
                </div>
              ))}
            </React.Fragment>
          ))
        )}
      </section>

      {action !== "N" && (
        <section className="rfus-bottom-btn">
          <button
            className="rfus-btn-log"
            onClick={() => {
              window.location.href = `/report-flare-up?${buildQs()}`;
            }}
          >
            {t("flareUpStats.logBtn", "Report Flare-up")}
          </button>
        </section>
      )}
    </>
  );
};

export default ReportFlareUpStats;
